import PropTypes from 'prop-types'
import React from 'react'
import {isIE,isMobile} from 'shared/src/misc/constants'

function Footer(props){
    return(
        <React.Fragment>
            <div id="footer" className="row container-fluid clean">
                <div className="row">
                    <div className="col-md-2 col-sm-12"><strong className="footer-help">Need Help?</strong></div>
                    <div className="col-md-8 quick-actions">
                        <FooterIconGroup
                            header="Call us"
                            text="604-654-2000"
                            icon="phn"
                            link="tel:604-654-2000"
                        />
                        <FooterIconGroup
                            header="Email us"
                            text="info@comsavings.com"
                            icon="mail"
                            link="mailto:info@comsavings.com"
                        />
                        <FooterIconGroup
                            header="Feedback"
                            text="Rate your experience"
                            icon="fdbck"
                            link="https://forms.office.com/Pages/ResponsePage.aspx?id=gLd9mhHQK0meCNAgbwIXMexTmKUH-QhHpIgkUKPQfFpUNThSTlk3NTdGUU5USDhNVlNGTjgxTjVWSi4u"
                        />
                    </div>
                    <div className="col-md-2">
                        <span className="text-align-xl-right">Find us on social media</span>
                        <div className="socialmedialink-group" style={isIE()==="IE" && !isMobile() ? {display: 'flex', justifyContent: 'flex-end'} : {}}> {/*IE Fix for max-content not being supported*/}
                            <SocialMediaLink 
                                link="https://www.facebook.com/CommunitySavings/"
                                icon="facebook"
                            />
                            <SocialMediaLink 
                                link="https://twitter.com/ComSavings"
                                icon="twitter"
                            />
                            <SocialMediaLink 
                                link="https://www.instagram.com/comsavings/?hl=en"
                                icon="instagram"
                            />
                            <SocialMediaLink 
                                link="https://www.linkedin.com/company/community-savings-credit-union-bc/?originalSubdomain=ca"
                                icon="linkedin"
                            />
                        </div>
                    </div>
                </div>
                <div id="copyright"><small>© 2021 Community Savings Credit Union. All rights reserved.</small></div>
            </div>
        </React.Fragment>
    )
}


Footer.propTypes = {
    background: PropTypes.string.isRequired
}


function SocialMediaLink(props){
    return(
        <div className="socialmedialink">
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a href={props.link} title={props.icon} className={`fab ${props.icon}`} target="_blank" rel="external"><span style={{display: 'none'}}>{props.icon}</span></a>
        </div>
    )
}
SocialMediaLink.propTypes = {
    link: PropTypes.string.isRequired,
    icon: PropTypes.oneOf(["facebook","twitter","instagram","linkedin"])
}

function FooterIconGroup(props){
    return(
        <div className="footericon-group">
            <div className={`fa icon ${props.icon}`}></div>
            <a className="footer-twolinetext" href={props.link} onClick={
                 (e) => {
                     e.preventDefault()
                     let link = document.createElement('a')
                         link.href  = props.link
                         link.target = "_blank"
                     link.click()
                 } 
                }>
                <div className="footergroup-header">{props.header}</div>
                <div className="footergroup-text">{props.text}</div>
            </a>
        </div>
    )
}

FooterIconGroup.propTypes = {
    header: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    icon: PropTypes.oneOf(["phn","mail","fdbck"]),
    link: PropTypes.string.isRequired
}


export default Footer;